import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export interface WorkspaceSettings {
  workspaceUrl?: string;
  defaultUrl?: string;
}

interface WorkspaceSettingsContextValue {
  settings: WorkspaceSettings;
}

const WorkspaceSettingsContext = createContext<WorkspaceSettingsContextValue>({
  settings: {},
});

interface WorkspaceSettingsProviderProps {
  settings?: WorkspaceSettings;
  children: ReactNode;
}

export function WorkspaceSettingsProvider({ settings, children }: WorkspaceSettingsProviderProps) {
  const value: WorkspaceSettingsContextValue = {
    settings: settings ?? {},
  };

  return (
    <WorkspaceSettingsContext.Provider value={value}>
      {children}
    </WorkspaceSettingsContext.Provider>
  );
}

export function useWorkspaceSettings(): WorkspaceSettingsContextValue {
  return useContext(WorkspaceSettingsContext);
}
